import React from "react";
import { Arrow } from "./MarketingShell";

export type TimelineEntry = { date: string; dateTime: string; title: string; text: string; status?: string; href?: string; linkLabel?: string };
export default function DatedTimeline({ entries, label }: { entries: TimelineEntry[]; label: string }) {
  return <ol className="dated-timeline" aria-label={label}>
    {entries.map((entry,index) => <li key={`${entry.date}-${index}`} className={entry.status === "goal" ? "timeline-goal" : undefined}>
      <div className="timeline-date"><time dateTime={entry.dateTime}>{entry.date}</time></div>
      <h3>{entry.title}</h3><p>{entry.text}</p>
      {entry.href && <a className="quant-text-link" href={entry.href}>{entry.linkLabel}<Arrow /></a>}
    </li>)}
  </ol>;
}
